import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "card-content"
};
const _hoisted_2 = {
  class: "stage-image-container"
};
const _hoisted_3 = {
  class: "drama-info"
};
const _hoisted_4 = {
  class: "info-container"
};
const _hoisted_5 = {
  class: "stage-info"
};
const _hoisted_6 = {
  class: "second-info"
};
const _hoisted_7 = {
  class: "stage-image-container"
};
const _hoisted_8 = {
  class: "drama-info"
};
const _hoisted_9 = {
  class: "info-container"
};
const _hoisted_10 = {
  class: "stage-info"
};
const _hoisted_11 = {
  class: "second-info"
};
const _hoisted_12 = {
  class: "second-info"
};
const _hoisted_13 = {
  class: "second-info"
};
const _hoisted_14 = {
  class: "second-info"
};
const _hoisted_15 = {
  class: "staff-info"
};
const _hoisted_16 = {
  class: "staff-progress-container"
};
const _hoisted_17 = {
  class: "staff-info"
};
const _hoisted_18 = {
  key: 0,
  class: "unavailable"
};
const _hoisted_19 = {
  key: 1
};
const _hoisted_20 = {
  class: "staff-progress-container"
};
const _hoisted_21 = {
  key: 1,
  style: {
    "height": "1.6rem"
  }
};
const _hoisted_22 = {
  key: 0,
  class: "card-content"
};
const _hoisted_23 = {
  class: "stage-image-container"
};
const _hoisted_24 = {
  class: "drama-info"
};
const _hoisted_25 = {
  class: "info-container"
};
const _hoisted_26 = {
  class: "stage-info"
};
const _hoisted_27 = {
  class: "anchor"
};
const _hoisted_28 = {
  class: "second-info"
};
const _hoisted_29 = {
  class: "second-info"
};
const _hoisted_30 = {
  class: "second-info"
};
import { computed, inject, ref } from 'vue';
import { ElButton, ElImage, ElRow } from 'element-plus';
import { getPerformanceDesc, getDifficultyDegree, inApostleType, isUserType } from '@/tools/utils';
import store from '@/store';
import router from '@/router';
import RecruitmentProgressIndicator from '@/components/Stage/RecruitmentProgressIndicator.vue';
export default {
  __name: 'RecruitmentStageCard',
  props: {
    data: {
      type: [Object, null],
      required: true,
      default: null
    }
  },

  setup(__props) {
    const props = __props;
    const stageService = inject('stageService'); // refs

    const ticketType = ref(null); // computed

    const userType = computed(() => store.state.user ? parseInt(store.state.user.user_type) : 4);
    const audienceJoinable = computed(() => {
      if (props.data.audience_capacity === 0) return -1;
      if (audienceNumber.value >= props.data.audience_capacity) return 0;
      return 1;
    });
    const castNumber = computed(() => {
      return props.data.actor_number;
    });
    const audienceNumber = computed(() => {
      return props.data.audience_number;
    });
    const actorStatus = computed(() => {
      if (!props.data.applications || props.data.applications.length === 0) return -1;
      let buffer = props.data.applications.filter(item => item.position === 0);
      if (buffer.length === 0) return -1;
      return buffer[0].status;
    });
    const audienceStatus = computed(() => {
      if (!props.data.applications || props.data.applications.length === 0) return -1;
      let buffer = props.data.applications.filter(item => item.position === 1);
      if (buffer.length === 0) return -1;
      return buffer[0].status;
    }); // functions

    const loadStage = () => {
      if (inApostleType(userType.value) || audienceStatus.value === 2 || actorStatus.value === 2) {
        store.commit('update_stage', props.data);
        router.push(`/stage`);
      } else {
        router.push(`/dramaDetail/${props.data.performance.drama.drama_id}`);
      }
    };

    const getAudienceStatus = () => {
      if (audienceNumber.value >= props.data.audience_capacity) return '观众席满员';
      if (audienceStatus.value === -1) return '申请观众席';

      switch (audienceStatus.value) {
        case 0:
          return '观众位申请中';

        case 2:
          return '已处于观众位';

        default:
          return '申请观众席';
      }
    };

    const getActorStatus = () => {
      if (castNumber.value >= props.data.actor_capacity) return '招募满员';
      if (actorStatus.value === -1) return '提交履历';

      switch (actorStatus.value) {
        case 0:
          return '角色申请中';

        case 2:
          return '角色已参演';

        default:
          return '提交履历';
      }
    };

    const getTicket = (event, type) => {
      switch (type) {
        case 'audience':
          ticketType.value = 1;
          break;

        case 'actor':
          ticketType.value = 0;
          break;

        default:
          break;
      }

      stageService.stage_apply(props.data, ticketType.value);
      event.stopPropagation();
    };

    const updateStage = event => {
      stageService.stage_update(props.data.stage_id);
      event.stopPropagation();
    };

    const shareStageCode = event => {
      stageService.stage_share(props.data);
      event.stopPropagation();
    };

    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");

      return _unref(inApostleType)(userType.value) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["stage-card", __props.data === null ? 'stage-card-empty' : ''])
      }, [__props.data === null ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[5] || (_cache[5] = [_createElementVNode("text", null, "空置舞台", -1)]))])) : !__props.data.available ? (_openBlock(), _createBlock(_component_el_col, {
        key: 1,
        class: "card-content",
        onClick: loadStage
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("text", _hoisted_3, " 「" + _toDisplayString(__props.data.performance?.drama?.name) + " / " + _toDisplayString(_unref(getDifficultyDegree)(__props.data.performance?.drama?.difficulty)) + "」 ", 1)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("text", _hoisted_5, [_createElementVNode("b", null, _toDisplayString(__props.data.stage_name), 1)]), _createElementVNode("span", _hoisted_6, " [" + _toDisplayString(`${__props.data.performance?.start_date} ~ ${__props.data.performance?.end_date}`) + "]   ", 1), _cache[6] || (_cache[6] = _createElementVNode("span", {
          class: "second-info"
        }, " [已结束] ", -1))]), _createVNode(_unref(ElRow), {
          class: "staff-container"
        }), _createVNode(_unref(ElRow), {
          class: "operator-bar"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElButton), {
            onClick: _cache[0] || (_cache[0] = $event => updateStage($event))
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode(" 舞台调整 ", -1)]))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_el_col, {
        key: 2,
        class: "card-content",
        onClick: loadStage
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_unref(ElImage), {
            src: __props.data.stage_image ?? __props.data.performance?.drama?.image_url,
            fit: "contain",
            draggable: false
          }, null, 8, ["src"]), _createElementVNode("text", _hoisted_8, " 「" + _toDisplayString(__props.data.performance?.drama?.name) + " / " + _toDisplayString(_unref(getDifficultyDegree)(__props.data.performance?.drama?.difficulty)) + "」 ", 1)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("text", _hoisted_10, [_createElementVNode("b", null, _toDisplayString(__props.data.stage_name), 1)]), _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)), _createElementVNode("span", _hoisted_11, " [" + _toDisplayString(__props.data.public ? '公开招募' : '私下筹备') + "]   [舞台" + _toDisplayString(__props.data.joinable ? '募集中' : '中止募集') + "]   [演出" + _toDisplayString(_unref(getPerformanceDesc)(__props.data.performance?.status)) + "] ", 1), _createElementVNode("span", _hoisted_12, " [演出时间：" + _toDisplayString(`${__props.data.performance?.start_date} ~ ${__props.data.performance?.end_date}`) + "]   ", 1), _createElementVNode("span", _hoisted_13, " [预期时长：" + _toDisplayString(__props.data.performance?.drama.construction_period) + "] ", 1), _createElementVNode("span", _hoisted_14, " [" + _toDisplayString(__props.data.performance?.drama.era) + " / " + _toDisplayString(__props.data.performance?.drama.location) + "] ", 1)])]),
          _: 1
        }), _cache[12] || (_cache[12] = _createElementVNode("div", {
          class: "divider"
        }, null, -1)), _createVNode(_unref(ElRow), {
          class: "staff-container"
        }, {
          default: _withCtx(() => [_createElementVNode("text", _hoisted_15, _toDisplayString(castNumber.value >= __props.data.actor_capacity ? '演职员（已满）' : `演职员（${castNumber.value} / ${__props.data.actor_capacity}）`), 1), _createElementVNode("div", _hoisted_16, [_createVNode(RecruitmentProgressIndicator, {
            current: castNumber.value,
            "show-number": __props.data.actor_capacity,
            total: Math.max(__props.data.audience_capacity, __props.data.actor_capacity),
            "start-color": "#0D6E6E",
            "end-color": "#d17668"
          }, null, 8, ["current", "show-number", "total"])]), _createElementVNode("text", _hoisted_17, [_cache[9] || (_cache[9] = _createTextVNode(" 观众席 ", -1)), audienceJoinable.value === -1 ? (_openBlock(), _createElementBlock("span", _hoisted_18, " （未开放） ")) : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(`（${audienceNumber.value} / ${__props.data.audience_capacity}）`), 1))]), _createElementVNode("div", _hoisted_20, [_createVNode(RecruitmentProgressIndicator, {
            current: audienceNumber.value,
            "show-number": __props.data.audience_capacity,
            total: Math.max(__props.data.audience_capacity, __props.data.actor_capacity),
            "start-color": "#0D6E6E",
            "end-color": "#d17668"
          }, null, 8, ["current", "show-number", "total"])])]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          class: "operator-bar"
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElButton), {
            onClick: _cache[1] || (_cache[1] = $event => updateStage($event))
          }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode(" 舞台调整 ", -1)]))]),
            _: 1
          }), !__props.data.public ? (_openBlock(), _createBlock(_unref(ElButton), {
            key: 0,
            onClick: _cache[2] || (_cache[2] = $event => shareStageCode($event))
          }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode(" 分享邀请码 ", -1)]))]),
            _: 1
          })) : (_openBlock(), _createElementBlock("div", _hoisted_21))]),
          _: 1
        })]),
        _: 1
      }))], 2)) : _unref(isUserType)(userType.value) ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["stage-card", __props.data === null ? 'stage-card-empty' : ''])
      }, [__props.data === null ? (_openBlock(), _createElementBlock("div", _hoisted_22, [...(_cache[13] || (_cache[13] = [_createElementVNode("text", null, "等待募集", -1)]))])) : (_openBlock(), _createBlock(_component_el_col, {
        key: 1,
        class: "card-content",
        onClick: loadStage
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_23, [_createVNode(_unref(ElImage), {
            src: __props.data.stage_image ?? __props.data?.performance?.drama?.image_url,
            fit: "contain",
            draggable: false
          }, null, 8, ["src"]), _createElementVNode("text", _hoisted_24, " 「" + _toDisplayString(__props.data.performance?.drama?.name) + " / " + _toDisplayString(_unref(getDifficultyDegree)(__props.data.performance?.drama?.difficulty)) + "」 ", 1)]), _createElementVNode("div", _hoisted_25, [_createElementVNode("text", _hoisted_26, [_createElementVNode("b", null, _toDisplayString(__props.data.stage_name), 1)]), _createElementVNode("span", _hoisted_27, " 链接者:" + _toDisplayString(__props.data.performance.anchor.name) + "  /  " + _toDisplayString(_unref(getPerformanceDesc)(__props.data.performance?.status)), 1), _createElementVNode("span", _hoisted_28, " [演出时间：" + _toDisplayString(`${__props.data.performance?.start_date} ~ ${__props.data.performance?.end_date}`) + "]   ", 1), _createElementVNode("span", _hoisted_29, " [预期时长：" + _toDisplayString(__props.data.performance?.drama.construction_period) + "] ", 1), _createElementVNode("span", _hoisted_30, " [" + _toDisplayString(__props.data.performance?.drama.era) + " / " + _toDisplayString(__props.data.performance?.drama.location) + "] ", 1)])]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          class: "operator-bar"
        }, {
          default: _withCtx(() => [__props.data.audience_capacity !== 0 && actorStatus.value === -1 ? (_openBlock(), _createBlock(_unref(ElButton), {
            key: 0,
            onClick: _cache[3] || (_cache[3] = $event => getTicket($event, 'audience')),
            class: _normalizeClass(audienceStatus.value === 2 ? 'active-stage' : ''),
            disabled: audienceNumber.value >= __props.data.audience_capacity || [0, 2].includes(audienceStatus.value)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(getAudienceStatus()), 1)]),
            _: 1
          }, 8, ["class", "disabled"])) : _createCommentVNode("", true), _cache[14] || (_cache[14] = _createElementVNode("div", {
            style: {
              "width": "0.6rem"
            }
          }, null, -1)), audienceStatus.value === -1 ? (_openBlock(), _createBlock(_unref(ElButton), {
            key: 1,
            onClick: _cache[4] || (_cache[4] = $event => getTicket($event, 'actor')),
            class: _normalizeClass(actorStatus.value === 2 ? 'active-stage' : ''),
            disabled: castNumber.value >= __props.data.actor_capacity || [0, 2].includes(actorStatus.value)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(getActorStatus()), 1)]),
            _: 1
          }, 8, ["class", "disabled"])) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }))], 2)) : _createCommentVNode("", true);
    };
  }

};